import api from './api';

export interface ScheduledEvent {
  id: string;
  title: string;
  description: string | null;
  event_type: string;
  scheduled_at: string | null;
  cron_expression: string | null;
  is_recurring: boolean;
  next_run_at: string | null;
  last_run_at: string | null;
  run_count: number;
  goal_id: string | null;
  project_id: string | null;
  task_id: string | null;
  owner_id: string | null;
  created_by_agent: boolean;
  status: string;
  payload: Record<string, any>;
  created_at: string;
  updated_at: string | null;
}

export interface ScheduledEventCreate {
  title: string;
  description?: string;
  event_type?: string;
  scheduled_at?: string;
  cron_expression?: string;
  goal_id?: string;
  project_id?: string;
  task_id?: string;
  payload?: Record<string, any>;
}

export const scheduleService = {
  list: async (params?: Record<string, any>): Promise<ScheduledEvent[]> => {
    const resp = await api.get('/schedule', { params });
    return resp.data;
  },

  create: async (data: ScheduledEventCreate): Promise<ScheduledEvent> => {
    const resp = await api.post('/schedule', data);
    return resp.data;
  },

  get: async (id: string): Promise<ScheduledEvent> => {
    const resp = await api.get(`/schedule/${id}`);
    return resp.data;
  },

  update: async (id: string, data: Partial<ScheduledEventCreate> & { status?: string }): Promise<ScheduledEvent> => {
    const resp = await api.put(`/schedule/${id}`, data);
    return resp.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/schedule/${id}`);
  },

  upcoming: async (hours: number = 24): Promise<ScheduledEvent[]> => {
    const resp = await api.get('/schedule/upcoming', { params: { hours } });
    return resp.data;
  },
};
